var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PCH5\u5B8C\u6210") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-579.000000, -465.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-fill",
    transform: "translate(579.000000, 465.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,3 C12.403125,3 3,12.403125 3,24 C3,35.596875 12.403125,45 24,45 C35.596875,45 45,35.596875 45,24 C45,12.403125 35.596875,3 24,3 Z M33.0703125,17.1421875 L23.1984375,30.8296875 C22.603125,31.659375 21.3703125,31.659375 20.775,30.8296875 L14.9296875,22.7296875 C14.7515625,22.48125 14.9296875,22.134375 15.234375,22.134375 L17.4328125,22.134375 C17.9109375,22.134375 18.365625,22.3640625 18.646875,22.7578125 L21.984375,27.3890625 L29.353125,17.1703125 C29.634375,16.78125 30.084375,16.546875 30.5671875,16.546875 L32.765625,16.546875 C33.0703125,16.546875 33.2484375,16.89375 33.0703125,17.1421875 Z",
    id: "\\u5F62\\u72B6",
    fill: "#66B949"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fcae19490632f652a2a26d26dafe702c.svg";
export { ForwardRef as ReactComponent };